module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/documents/documents.component.html
// module id = ./src/app/components/dashboard/documents/documents.component.html
// module chunks = main